import type { PageContext } from 'vike/types'

export function title(pageContext: PageContext) {
    return 'Entreprise de rénovation | Demandez vos devis gratuits | Topela'
}